import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';

const ReportPage: FC = (): JSX.Element => {
  return (
    <Stack
      direction={'row'}
      sx={{ height: '100%', position: 'relative', backgroundColor: 'white' }}
    >
      <Box sx={{ pl: 1, backgroundColor: 'white', height: '100%', width: '0.5rem' }} />
      <Stack sx={{ flexGrow: 1, backgroundColor: '#e3e7eb' }}>
        <Outlet />
      </Stack>
    </Stack>
  );
};

export default ReportPage;
